export default __webpack_public_path__ + "static/media/statistic_dfy.16f1c86b.png";